import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { of } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { BodyUsedClient, CheckNameExistsRequest } from 'src/app/shared/api-connector/sso-connector';
import { AlertService } from 'src/app/shared/services/alert.service';
import { AutocompleteCacheService } from 'src/app/shared/services/autocomplete-cache.service';

@Component({
  selector: 'app-add-body-used-dialog',
  templateUrl: './add-body-used-dialog.component.html',
  styleUrls: ['./add-body-used-dialog.component.scss']
})
export class AddBodyUsedDialogComponent implements OnInit {

  nameCtrl = new FormControl('', {
    validators: [Validators.required],
    updateOn: 'change',
    asyncValidators: [this.validateBodyUsedNameNotTaken.bind(this)]
  });
  constructor(
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<AddBodyUsedDialogComponent>,
    private alertService: AlertService,
    private bodyUsedClient: BodyUsedClient,
    private autocompleteCache: AutocompleteCacheService
  ) { }

  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close();
  }

  validateBodyUsedNameNotTaken(control: FormControl): any {
    if (control.value) {
      return this.bodyUsedClient.checkBodyUsedNameExists(new CheckNameExistsRequest({
        name: this.nameCtrl.value
      })).pipe(
        map(res => {
          return res ? { categoryNameTaken: true } : null;
        }));
    } else {
      return of(null);
    }
  }

  onSubmit() {
    if (this.nameCtrl.valid) {
      this.spinner.show();
      this.bodyUsedClient.create(this.nameCtrl.value)
        .pipe(finalize(() => this.spinner.hide()))
        .subscribe(x => {
          this.autocompleteCache.clearType('body_used_');
          this.alertService.success('Thêm mới đường dùng thành công', 'Thêm đường dùng');
          this.dialogRef.close(this.nameCtrl.value);
        });
    }
  }
}
